import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { actions as authActions } from 'features/Auth';
import { actions } from 'features/users/redux';
import parseNumberFromString from 'shared/helpers/parseNumberFromString';

import { amountTypes } from '../data';

const useWithdrawalModel = () => {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const { username: authUsername, balance: authBalance, role: authRole, currency } = useSelector(state => state.auth);
  const history = useHistory();
  const locale = useSelector(state => state.locale.locale);
  const { userInfo, actionProcessing } = useSelector(state => state.users);
  const [amount, setAmount] = useState();

  useEffect(() => {
    dispatch(actions.getUserInfo({ id: userId, withParent: true }));
  }, [userId, dispatch]);

  const players = useMemo(
    () => [
      { username: userInfo.username, balance: userInfo.balance, role: userInfo.role, title: locale.from },
      {
        username: userInfo?.parentInfo?.username ?? authUsername,
        balance: userInfo?.parentInfo?.balance ?? authBalance,
        role: userInfo?.parentInfo?.role ?? authRole,
        title: locale.to,
      },
    ],
    [authBalance, authUsername, authRole, userInfo, locale],
  );

  const onSubmit = useCallback(() => {
    dispatch(
      actions.depositOrWithdrawal({
        amount,
        operation: 1,
        id: userId,
        callback: () => {
          dispatch(actions.getUserInfo({ id: userId }));
          dispatch(authActions.getBalance());
          history.push('/users/all');
        },
      }),
    );
  }, [amount, dispatch, userId, history]);

  const changeValue = useCallback(
    e => {
      const value = e?.currentTarget?.value ?? e;

      if (e?.currentTarget) {
        setAmount(() => parseNumberFromString(value));
      } else {
        setAmount(() => {
          // if (!Object.keys(amountTypes).includes(value)) return Number(value);
          return Number(value) + Number(parseNumberFromString(amount));
        });
      }
    },
    [amount],
  );

  return {
    players,
    amount,
    balance: authBalance,
    childBalance: userInfo.balance,
    onSubmit,
    changeValue,
    setAmount,
    currency,
    actionProcessing,
    locale,
    history,
  };
};

export default useWithdrawalModel;
